// TODO: merge into one get browser utility
export const isSafari = (): boolean => {
  const chromeInAgent = navigator.userAgent.includes('Chrome')
  const safariInAgent = navigator.userAgent.includes('Safari')
  return safariInAgent && !chromeInAgent
}
